import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/sections/Hero';
import TrustStrip from '../components/sections/TrustStrip';
import { HolidaysStrip, HowItWorksPreview, BlogPreview } from '../components/sections/EngagementSections';
import { DestinationsGrid, ThemesGrid } from '../components/sections/DestinationsGrid';
import { PackagesPreview } from '../components/sections/Packages';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import Testimonials from '../components/sections/Testimonials';
import EnquiryForm from '../components/sections/EnquiryForm';
import { CTABanner, FAQSection, PartnersStrip } from '../components/sections/CTASections';
import VideoGallery from '../components/sections/VideoGallery';
import ReviewCards from '../components/sections/ReviewCards';
import CustomerVideoReviews from '../components/sections/CustomerVideoReviews';
import { HOME_VIDEOS } from '../mock';


export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>Mountains Chain Travel | Custom Itinerary in 2 Minutes - Book With 20% Advance</title>
        <meta name="description" content="Custom Itinerary in 2 Minutes. Book With Just 20% Advance. Rated 4.9★ By 2,000+ Travelers. Watch Real Customer Stories." />
        <meta property="og:title" content="Mountains Chain Travel | Custom Itinerary in 2 Minutes - Book With 20% Advance" />
        <meta property="og:description" content="Custom Itinerary in 2 Minutes. Book With Just 20% Advance. Rated 4.9★ By 2,000+ Travelers. Watch Real Customer Stories." />
      </Helmet>
      <Hero />
      <ReviewCards />
      <CustomerVideoReviews />
      <HolidaysStrip />
      <DestinationsGrid />
      <VideoGallery 
        videos={HOME_VIDEOS} 
        title={<>Your Journey <span className="text-brand-orange text-gradient">Visualized</span></>}
        sub="A cinematic glimpse into the incredible experiences we craft for our travelers across the Himalayas."
      />
      <HowItWorksPreview />
      <div id="live-offers"><PackagesPreview /></div>
      <ThemesGrid />
      <div id="why-choose-us"><WhyChooseUs /></div>
      <div id="verified-reviews"><Testimonials /></div>
      <BlogPreview />
      <CTABanner />
      <div id="get-free-quote"><EnquiryForm /></div>
      <PartnersStrip />
      <FAQSection />
    </>
  );
}
